const item = Object.freeze({
  MarkAvailable: 1,
  Inactivate: 2,
  Eliminate: 3,
});
export default item;
